import React from 'react';
import {Link} from "react-router-dom";
import {getCurrentUserName} from "../../../services/authService";
import authService from "../../../services/authService";

const NoFeeds = (props) => {

    return (
        <div className="row">
            {/*{console.log('props: ',props)}*/}
            <div className="col-xs-12 text-center no-feeds-containers">
                <div className="feed-msg"><img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                    <p className="text-center ">{props.userFullName}</p><p>It looks like you haven't set up any
                        workspaces yet. Add your first workspace, and start growing your audience.</p>
                    <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/></div>
                <Link to='/workspace-name'>
                    <button className='btn-m btn-action' type="button">Create your first workspace</button>
                </Link>
            </div>
        </div>
    );
};

export default NoFeeds;
